// Shared client-side formatters. Mirror of the function-side format util so
// the modal, thank-you page, and donor portal all render money/dates the same.

export function formatMoney(amount, currency = 'USD') {
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: String(currency || 'USD').toUpperCase(),
      maximumFractionDigits: 2,
    }).format(amount || 0);
  } catch {
    return `${amount} ${currency}`;
  }
}

export function formatDate(d) {
  try {
    let date;
    // Parse a plain YYYY-MM-DD as a LOCAL date so it doesn't shift a day
    // backward in negative-UTC timezones. Full ISO timestamps parse as-is.
    if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const [y, m, day] = d.split('-').map(Number);
      date = new Date(y, m - 1, day);
    } else {
      date = new Date(d);
    }
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    }).format(date);
  } catch {
    return String(d);
  }
}

// every week / every month / every year / every 2 weeks ...
export function cadencePhrase(interval, count = 1) {
  const c = Number(count) || 1;
  if (!['week', 'month', 'year'].includes(interval)) return 'recurring';
  return c === 1 ? `every ${interval}` : `every ${c} ${interval}s`;
}
